import React from "react";
import styles from "../preview.module.css";

const DraggableZone = ({ draggable, onStartDragging, onStopDragging }) => {
  const startDrag = function (e) {
    e.preventDefault();
    let pos1, pos2;
    let pos3 = e.clientX;
    let pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;

    function elementDrag(e) {
      e.preventDefault();
      onStartDragging();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      draggable.current.style.top = draggable.current.offsetTop - pos2 + "px";
      draggable.current.style.left = draggable.current.offsetLeft - pos1 + "px";
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      onStopDragging();
      document.onmouseup = null;
      document.onmousemove = null;
    }
  };

  return (
    <div>
      <div
        className={`${styles.drag_zone} ${styles.drag_zone_top}`}
        onMouseDown={startDrag}
      />
      <div
        className={`${styles.drag_zone} ${styles.drag_zone_right}`}
        onMouseDown={startDrag}
      />
      <div
        className={`${styles.drag_zone} ${styles.drag_zone_bottom}`}
        onMouseDown={startDrag}
      />
      <div
        className={`${styles.drag_zone} ${styles.drag_zone_left}`}
        onMouseDown={startDrag}
      />
    </div>
  );
};

export default DraggableZone;
